import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const axe = require('@axe-core/react')
    axe(React, ReactDOM, 1000)
}

ReactDOM.render(<App />, document.getElementById('app'))
